import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyleFunc<boolean> = (close) => ({
  p: 2,
  pb: 5,
  display: close ? 'none' : 'inline-block',
});

export const closeIcon: SxStyle = {
  cursor: 'pointer',
};

export const title: SxStyle = {
  fontSize: (p) => p.typography.body1.fontSize,
  fontWeight: (p) => p.typography.fontWeightBold,
  my: 1,
};

export const description: SxStyle = {
  fontSize: (p) => p.typography.body2.fontSize,
  fontWeight: (p) => p.typography.fontWeightRegular,
};
